import { useState } from "react";
import { auth, provider, signInWithPopup, signOut } from "./firebase";

export default function Login({ onLogin }) {
  const [user, setUser] = useState(null);

  const handleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const ALLOWED_USERS = ["gowthamkamalasekar@gmail.com", "vaithia26@gmail.com"];
      
      if (!ALLOWED_USERS.includes(result.user.email)) {
        alert("Access Denied! This email is not authorized.");
        await signOut(auth); // Logout unauthorized user
        return;
      }
      setUser(result.user);
      onLogin(result.user); // Pass user data to parent
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };

  const handleSignOut = () => {
    signOut(auth);
    setUser(null);
    onLogin(null); // Reset user in parent
  };

  return (
    <div className="flex flex-col items-center p-5">
      {user ? (
        <>
          <h2 className="text-xl font-bold">Welcome, {user.displayName}!</h2>
          <img src={user.photoURL} alt="Profile" className="rounded-full w-20 h-20 mt-2" />
          <button onClick={handleSignOut} className="mt-4 p-2 bg-red-500 text-white rounded">
            Sign Out
          </button>
        </>
      ) : (
        <button onClick={handleSignIn} className="p-2 bg-blue-500 text-white rounded">
          Sign in with Google
        </button>
      )}
    </div>
  );
}
